import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { Language } from 'src/models/Language.model';

import createSelectors from './createSelectors';

type localStoreBaseState = {
  uiLanguage: Language;
  reportLanguage: Language;
  cameraIP: string | undefined;
  AIIntegratedResultsColsKeys: Record<string, boolean> | undefined;
  usersColsKeys: Record<string, boolean> | undefined;
  rememberUserEmail: string | undefined;
  isRememberEmail: boolean;
  hasExpandedSidebar: boolean;
  ssoState: string | undefined;
};

type localStoreBaseActions = {
  setUiLanguage: (language: Language) => void;
  setReportLanguage: (language: Language) => void;
  setCameraIP: (ip: string) => void;
  setAIIntegratedResultsColsKeys: (keys: Record<string, boolean>) => void;
  setUsersColsKeys: (keys: Record<string, boolean>) => void;
  setRememberUserEmail: (email: string | undefined) => void;
  setIsRememberEmail: (isRememberEmail: boolean) => void;
  setHasExpandedSidebar: (hasExpandedSidebar: boolean) => void;
  setSsoState: (ssoState: string) => void;
};

type localStoreBaseTypes = localStoreBaseState & localStoreBaseActions;

const localStoreBase = create<localStoreBaseTypes>()(
  immer(
    persist(
      (set) => ({
        uiLanguage: Language.ENGLISH,
        reportLanguage: Language.ENGLISH,
        cameraIP: undefined,
        AIIntegratedResultsColsKeys: undefined,
        usersColsKeys: undefined,
        rememberUserEmail: undefined,
        isRememberEmail: false,
        hasExpandedSidebar: false,
        ssoState: undefined,
        setUiLanguage: (language) => set({ uiLanguage: language }),
        setReportLanguage: (language) => set({ reportLanguage: language }),
        setCameraIP: (ip) => set({ cameraIP: ip }),
        setAIIntegratedResultsColsKeys: (keys) =>
          set({ AIIntegratedResultsColsKeys: keys }),
        setUsersColsKeys: (keys) => set({ usersColsKeys: keys }),
        setRememberUserEmail: (email) => {
          set({
            rememberUserEmail: email,
            isRememberEmail: email !== undefined,
          });
        },
        setIsRememberEmail: (isRememberEmail) => set({ isRememberEmail }),
        setHasExpandedSidebar: (hasExpandedSidebar) =>
          set({ hasExpandedSidebar }),
        setSsoState(ssoState: string) {
          set({ ssoState });
        },
      }),
      { name: 'optain-app-localStore' },
    ),
  ),
);

const useLocalStore = createSelectors(localStoreBase);

export default useLocalStore;
